import { createSelector } from "reselect";

const selectEntity = state => state.entities.entity_status;
const selectEntityData = state =>
  state.entities.entity_status && state.entities.entity_status.data
    ? state.entities.entity_status.data
    : {};

export const makeSelectEntityStatuses = () =>
  createSelector([selectEntityData], substate => substate);

export const makeSelectIsEntityStatusLoading = () =>
  createSelector(selectEntity, substate => {
    if (substate) return substate.isLoading;
    return true;
  });
